import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import About from './views/About'
import Listing from './views/Listing'
// import SoldProperty from './views/SoldProperty'
import Testimonial from './views/Testimonial'
import Detail from './views/Detail'
import Contact from './views/Contact'
import Calculator from './views/Calculator'
import HomeValue from './views/HomeValue'
import HomeZh from './views/zh/Home'
import AboutZh from './views/zh/About'
import ListingZh from './views/zh/Listing'
import DetailZh from './views/zh/Detail'
// import SoldPropertyZh from './views/zh/SoldProperty'
import TestimonialZh from './views/zh/Testimonial'
import ContactZh from './views/zh/Contact'
import CalculatorZh from './views/zh/Calculator'
import PropertyCarousel from './views/PropertyCarousel'
import PropertyCarouselZh from './views/zh/PropertyCarousel'

const meta = {
  title: 'Julia, real estate agent, Alhambra, Arcadia, San Marino',
  metaTags: [
    {
      name: 'description',
      content: 'Julia Zhao is a top real estate agent specialized in city of Alhambra, Arcadia, San Marino, Monterey, San Gabriel, Monterey Park, Temple City, Monrovia, Pasadena, and South Pasadena. Julia Zhao can sell your house at best price and help buy a dream house.'
    }
    ,
    {
      property: 'keywords',
      content: 'Realtor Alhambra, Realtor San Marino, Realtor Arcadia, Realtor Monterey Park, Realtor San Gabriel, Real estate agent in Alhambra, Real estate agent in San Marino, Real estate agent Arcadia, Real estate agent Monterey Park, Real estate agent San Gabriel, Real estate broker Alhambra, Real estate broker San Marino, Real estate broker Arcadia, Real estate broker Monterey Park, Real estate broker San Gabriel, sell house Alhambra, sell house San Marino, sell house Arcadia, sell house Monterey Park, sell house San Gabriel'
    },
    {
      property: 'og:title',
      content: 'Julia, real estate agent, Alhambra, Arcadia, San Marino.'
    },
    {
      property: 'og:description',
      content: 'Julia Zhao is a top real estate agent specialized in city of Alhambra, Arcadia, San Marino, Monterey, San Gabriel, Monterey Park, Temple City, Monrovia, Pasadena, and South Pasadena. Julia Zhao can sell your house at best price and help buy a dream house.'
    }
  ]
}
const metaZh = {
  title: 'Julia Zhao, 洛杉矶地区资深华人房地产经纪人, 阿尔汉布拉, 亚凯迪亚, 圣马力诺',
  metaTags: [
    {
      name: 'description',
      content: 'Julia Zhao 是洛杉矶地区资深华人房地产经纪人，业务地区包括阿尔汉布拉, 亚凯迪亚, 圣马力诺, 蒙特雷, 圣加布里埃尔, 蒙特雷帕克, 坦普尔市, 蒙诺维亚, 帕萨迪纳, 南帕萨迪纳'
    }
    ,
    {
      property: 'keywords',
      content: '华人房地产经纪人，洛杉矶地区房地产中介'
    },
    {
      property: 'og:title',
      content: 'Julia, 洛杉矶地区资深华人房地产经纪人, 阿尔汉布拉, 亚凯迪亚, 圣马力诺'
    },
    {
      property: 'og:description',
      content: 'Julia Zhao是洛杉矶地区资深华人房地产经纪人，业务地区包括阿尔汉布拉, 亚凯迪亚, 圣马力诺, 蒙特雷, 圣加布里埃尔, 蒙特雷帕克, 坦普尔市, 蒙诺维亚, 帕萨迪纳, 南帕萨迪纳'
    }
  ]
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          component: PropertyCarousel,
          meta: meta
        },
        {
          path: 'home',
          component: PropertyCarousel,
          meta: meta
        },
        {
          path:'about',
          component: About,
          meta: meta
        },
        {
          path: 'listing',
          component: Listing,
          meta: meta
        },
        // {
        //   path: 'sold',
        //   component: SoldProperty
        // },
        {
          path: 'testimonial',
          component: Testimonial,
          meta: meta
        },
        {
          path: 'detail',
          component: Detail,
          meta: meta
        },
        {
          path: 'calculator',
          component: Calculator,
          meta: meta
        },
        {
          path: 'homevalue',
          component: HomeValue,
          meta: meta
        },
        {
          path: 'contact',
          component: Contact,
          meta: meta
        },
        // {
        //   path: 'cities',
        //   component: Cities,
        //   meta: meta
        // },
        // {
        //   path: 'city/alhambra',
        //   component: CityAlhambra,
        //   meta: meta
        // },
        // {
        //   path: 'city/arcadia',
        //   component: CityArcadia,
        //   meta: meta
        // },
        // {
        //   path: 'city/montereyPark',
        //   component: CityMontereyPark,
        //   meta: meta
        // },
        // {
        //   path: 'city/pasadena',
        //   component: CityPasadena,
        //   meta: meta
        // },
        // {
        //   path: 'city/sanGabriel',
        //   component: CitySanGabriel,
        //   meta: meta
        // },
        // {
        //   path: 'city/sanMarino',
        //   component: CitySanMarino,
        //   meta: meta
        // },
        // {
        //   path: 'city/southPasadena',
        //   component: CitySouthPasadena,
        //   meta: meta
        // },
        // {
        //   path: 'city/templeCity',
        //   component: CityTempleCity,
        //   meta: meta
        // }
      ]
    },
    {
      path: '/zh',
      component: HomeZh,
      children: [
        {
          path: '',
          component: PropertyCarouselZh,
          meta: metaZh
        },
        {
          path: 'home',
          component: PropertyCarouselZh,
          meta: metaZh
        },
        {
          path:'about',
          component: AboutZh,
          meta: metaZh
        },
        {
          path: 'listing',
          component: ListingZh,
          meta: metaZh
        },
        // {
        //   path: 'sold',
        //   component: SoldPropertyZh
        // },
        {
          path: 'testimonial',
          component: TestimonialZh,
          meta: metaZh
        },
        {
          path: 'detail',
          component: DetailZh,
          meta: metaZh
        },
        {
          path: 'calculator',
          component: CalculatorZh,
          meta: metaZh
        },
        {
          path: 'homevalue',
          component: HomeValue
        },
        {
          path: 'contact',
          component: ContactZh,
          meta: metaZh
        }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition?savedPosition:{ x: 0, y: 0 }
  }
})
  router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
})

export default router
